import {fromJS, List} from 'immutable'

const existingConversation = (convId, conv) => conv.get('conversationId') === convId

export default (conversationId, stack) => {
  if (typeof(stack) === 'undefined' || stack === null) stack = fromJS([])
  if (!List.isList(stack)) stack = fromJS(stack)
  if (!conversationId) return stack

  const index = stack.findKey(existingConversation.bind(null, conversationId))

  if (index >= 0) stack = stack.delete(index)

  return stack
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/remove_conversation_from_stack.js
 **/